export const findContext = function () {
  // return 'mexreps'
  // return 'colreps'
  if (/fitness\.org\.mx/.test(window.location.host)) {
    return 'mexreps'
  }
  if (/repscolombia/.test(window.location.host)) {
    return 'colreps'
  }
  if (/fitnesscolombia/.test(window.location.host)) {
    return 'colreps'
  }
  if (/colreps/.test(window.location.host)) {
    return 'colreps'
  }

  return 'esreps'
}



// WEBPACK FOOTER //
// ./src/components/services/Tools.js